<template>
    <div class="image-create">
        <b-button class="hover btn-outline-primary" href="javascript: void(0)" @click="this.triggerFileUpload" variant="default">{{message}}</b-button>
        <input type="file" name="image" accept="image/*" class="img-src" ref="fileInput" @change="this.setImage"/>

        <b-modal id="imgUploadModal" ref="modal" title="Edit Image" class="new-address-modal" size="lg" @ok="this.submitImage" @hide="this.clearImage">
            <div class="cropper-toolbar">
                <b-button-group>
                    <b-button @click="this.zoomIn"><i class="fa fa-search-plus"></i></b-button>
                    <b-button @click="this.zoomOut"><i class="fa fa-search-minus"></i></b-button>
                </b-button-group>
                <b-button-group>
                    <b-button @click="this.rotateLeft"><i class="fa fa-rotate-left"></i></b-button>
                    <b-button @click="this.rotateRight"><i class="fa fa-rotate-right"></i></b-button>
                </b-button-group>
            </div>
            <vue-cropper
                ref="cropper"
                :src="imgSrc"
                alt="Source Image"
                :cropmove="cropImage">
            </vue-cropper>
        </b-modal>
    </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
    name: 'image-create',
    components: { VueCropper},

    props: {
        agent: {
            type: Object,
            default: () => {}
        },
        message: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            imgSrc: '',
            cropImg: ''
        }
    },

    methods: {
        triggerFileUpload () {
            this.$refs.fileInput.click()
        },
        setImage (e) {
            const file = e.target.files[0];

            if (!file.type.includes('image/')) {
                alert('Please select an image file');
                return;
            }

            if (typeof FileReader === 'function') {
                const reader = new FileReader();

                reader.onload = (event) => {
                    this.imgSrc = event.target.result;
                    this.$refs.cropper.replace(event.target.result);
                };

                reader.readAsDataURL(file);
            } else {
                alert('Sorry, FileReader API not supported');
            }

            this.$refs.modal.show()
        },
        clearImage () {
            this.$refs.fileInput.value = null;
        },
        cropImage () {
            // get image data for post processing, e.g. upload or setting image src
            this.cropImg = this.$refs['cropper'].getCroppedCanvas().toDataURL();
        },
        rotateLeft () {
            this.$refs['cropper'].rotate(-90);
        },
        rotateRight () {
            this.$refs['cropper'].rotate(90);
        },
        zoomIn () {
            this.$refs['cropper'].relativeZoom(0.1);
        },
        zoomOut () {
            this.$refs['cropper'].relativeZoom(-0.1);
        },
        submitImage () {
            this.cropImage();
            this.$emit('image-uploaded', this.cropImg, this.agent)
        }
    }
}
</script>

<style lang="scss">
.image-create {
    .cropper-toolbar {
        margin-bottom: 6px;

        .btn-group {
            margin-right: 4px;
        }
    }

    .cropper-img {
        display: inline-block;
        max-width: 900px;
    }

    .img-src {
        display: none;
    }

    .cropped {
        border: 1px solid gray;
        height: 150px;
        width: 200px;
    }

    .hover:hover {
        color: blue;
    }
}
</style>
